import { combineReducers } from 'redux';
import cartItems from 'arts/reducers/cart_items';
import panel from './panel';
import works from './works';
import favoriteWorks from './favoriteWorks';
import workDetails from './work_details';
import customImage from './custom_image';
import wallPaper from './wall_paper';
import canvas from './canvas';
import undos from './undos';
import exportReducer from './export';
import currentIndex from './current_index';
import savingWall from './saving_wall';
import moreLikeThis from './more_like_this';
import hangings from './hangings';
import crop from './crop';
import pin from './pin';

export default combineReducers({
  panel,
  works,
  workDetails,
  canvas,
  customImage,
  wallPaper,
  undos,
  currentIndex,
  savingWall,
  exporting: exportReducer,
  moreLikeThis,
  crop,
  hangings,
  pin,
  favoriteWorks,
  cartItems
});
